/**
 * Vite env access (replaces CRA process.env.REACT_APP_*).
 * Vite only exposes variables prefixed with VITE_.
 */
const viteEnv = import.meta.env;

export const env = {
  apiBaseUrl:
    viteEnv.VITE_API_BASE_URL || 'http://localhost:5000/api/v1',
  gaMeasurementId: viteEnv.VITE_GA_MEASUREMENT_ID || '',
  plausibleDomain: viteEnv.VITE_PLAUSIBLE_DOMAIN || '',
  isDev: viteEnv.DEV,
  isProd: viteEnv.PROD,
} as const;
